import request from '../../utils/request';

export const quotationSearchService = {
    //DC列表数据查询
    getQuotationListData: (data) => {
        return request({
            url: '/quotation/list',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    }
}